import React, { useState, useEffect } from 'react'
import { Container, Col, Row, Image,Modal } from "react-bootstrap";
import { apiUrl } from "../commons/inFormTypes";
import { IPUrl } from "../commons/IPAddress";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { NavLink, useNavigate } from "react-router-dom";
import { useSpring, animated } from 'react-spring'
import BigLoaders from "../components/BigLoaders";


function Guidance() {
  const [groupId, setGroupId] = useState(0);
  const [ categoryList,setCategoryList ] = useState([])
  const [show, setShow] = useState(false);
  const [snip, setSnip] = useState(false);
  const [selectFile, setSelectFile] = useState(false);
  const [fileType, setFileType] = useState(1);
  const [seenFile, setSeenFile] = useState([]);
  const userToken = localStorage.getItem("user_token");
  const navigate = useNavigate()

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const imageFileBtn = useSpring({
    borderBottom: selectFile
      ? "solid 4px transparent"
      : "solid 4px #E78E09",
  });

  const videoFileBtn = useSpring({
    borderBottom: selectFile
      ? "solid 4px #E78E09"
      : "solid 4px transparent",
  });

  const videoFileClicked = () => {
    setSelectFile(true);
    setFileType(2);
    setGroupId(0);
  }

  const imageFileClicked = () => {
    setSelectFile(false);
    setFileType(1);
    setGroupId(0);
  }


  useEffect(() => {
    if (userToken == null) {
      navigate("/");
    } else {
      const axios = require("axios");
      setSnip(true);
      axios
        .post(apiUrl + "Get_FileEducate", {
          TokenId: userToken,
          Type: fileType,
          GroupId: groupId,
        })

        .then((res) => {
          setSnip(false);
          if (res.data.result === "true") {
            setSeenFile(res.data.data)
            setCategoryList(res.data.data_Nodes)
          } else {
          }
        })
        .catch(function (error) {
          if (error.response) {
            toast.error(error.response.data.message, {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }
        });
    }
  }, [fileType,groupId]);

  const selectCateporyHandler = (val) => {
    setGroupId(val);
    setShow(false);
      // const axios = require("axios")
      // axios.
      //   post(apiUrl + "Get_FileEducate", {
      //     TokenId: userToken,
      //     Type: fileType,
      //     GroupId: val,
      //   }) 
      //   .then((res) => {
      //     setShow(false);
      //     if(res.data.result === true) {
        
      //     } else {

      //     }
      //   })
      //   .catch(function (error) {
      //     if (error.response) {
      //       toast.error(error.response.data.message, {
      //         position: "top-center",
      //         autoClose: 5000,
      //         hideProgressBar: false,
      //         closeOnClick: true,
      //         pauseOnHover: true,
      //         draggable: true,
      //         progress: undefined,
      //       });
      //     }
      //   });
  }

  return (
    <div>
      <Container>
        <Row className="justify-content-center">
          <Col xs={12} lg={8} className="rgc-request p-4 rgc-profile ">
            <Row className="justify-content-start">

            <Col xs={5} md={8}>
              <div className="d-flex rgc-title">
                <div className="rgc-title-point"></div>
                <h4>فایل <span>آموزشی</span></h4>
              </div>
              </Col>

              <Col xs={7} md={4}>
              <div className='rgc-edu-btn' onClick={handleShow}>
                  <span>دسته بندی فایل های آموزشی</span>   
                  <i className='fas fa-chevron-down'></i>
              </div>
              </Col>

              <Col xs={12} className="my-3">
                <Row className="justify-content-center">

                  <Col xs={4} md={3} >
                    <animated.button
                      onClick={imageFileClicked}
                      id="loginBtn"
                      style={imageFileBtn}
                      className='rgc-select-btn'
                    >
                      <span >فایل تصویری</span>
                    </animated.button>
                  </Col>

                  <Col xs={4} md={3} className="rgc-dash-filter">
                    <animated.button
                      className='rgc-select-btn'
                      onClick={videoFileClicked}
                      id="registerBtn"
                      style={videoFileBtn}
                    >
                      <span>فایل ویدئویی</span>
                    </animated.button>
                  </Col>
                </Row>
              </Col>

              <BigLoaders loads={snip} />
              {seenFile.map((data, index) => {
                return (
                  fileType === 1 ?
                    <Col xs={12} md={6} key={index} className="my-2">
                      <NavLink to={`../internalimage/${data.id}`}>
                        <div className='d-flex flex-column rgc-video-content'>
                          <Image type="image/jpg" src={IPUrl + data.Picture} className="rgc-edu-img" />
                          <span>{data.Title}</span>
                          <hr />
                        </div>
                      </NavLink>
                    </Col>
                    :
                    <Col xs={12} md={6} key={index} className="my-2">
                      <NavLink to={`../InternalVideo/${data.id}`}>
                        <div className='d-flex flex-column rgc-video-content'>
                         <div className="rgc-edu">
                            <Image type="image/jpg" src={IPUrl + data.Picture} className="rgc-edu-img" />
                            <div className="rgc-edu-icon">
                              <i className="fa-solid fa-circle-play"></i>
                            </div>
                          </div>

                        </div>
                      </NavLink>
                    </Col>
                )
              })}

            </Row>
          </Col>
        </Row>

                <Modal
                  show={show}
                  onHide={handleClose}
                  backdrop="static"
                  keyboard={false}
                >
                  <Modal.Header closeButton>
                    <Modal.Title></Modal.Title>
                  </Modal.Header>
                  <Modal.Body >
                    <div className="rgc-edu-modal">
                       <ul className='rgc-edu-list'>
                        {categoryList.map((data, index) => {
                          return(
                            <li key={index}  onClick={() => selectCateporyHandler(data.id)}>
                              {data.NodeTitle}
                            </li>
                          )
                        })}                       
                       </ul>
                    </div>
                  </Modal.Body>
                </Modal>
      </Container>
    </div>
  )
}

export default Guidance